var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49971 16.5001H2.99974V27C2.99974 28.6545 4.34527 30 5.99981 30H24.0002C25.6547 30 27.0003 28.6545 27.0003 27V16.5001H28.5003C28.7969 16.5001 29.0869 16.4121 29.3335 16.2472C29.5801 16.0824 29.7723 15.8482 29.8858 15.5741C29.9993 15.3001 30.029 14.9985 29.9712 14.7076C29.9133 14.4167 29.7705 14.1494 29.5608 13.9397L16.0605 0.439797C15.9213 0.30038 15.756 0.189774 15.5741 0.114309C15.3921 0.0388437 15.197 0 15 0C14.803 0 14.6079 0.0388437 14.4259 0.114309C14.244 0.189774 14.0787 0.30038 13.9395 0.439797L0.43919 13.9397C0.229471 14.1494 0.0866584 14.4167 0.0288058 14.7076C-0.0290467 14.9985 0.000658441 15.3001 0.114166 15.5741C0.227673 15.8482 0.419887 16.0824 0.666507 16.2472C0.913127 16.4121 1.20308 16.5001 1.49971 16.5001ZM11.9999 27V19.5001H18.0001V27H11.9999ZM15 3.62127L24.0002 12.6212V19.5001L24.0017 27H21.0001V19.5001C21.0001 17.8456 19.6546 16.5001 18.0001 16.5001H11.9999C10.3454 16.5001 8.99987 17.8456 8.99987 19.5001V27H5.99981V12.6212L15 3.62127Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainGray);
export default __webpack_public_path__ + "static/media/mainGray.d2b85a3803d2a60be878ace1e62695e3.svg";
export { ForwardRef as ReactComponent };